var _defs, _circle, _path, _path2, _path3, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngryUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2,.cls-3{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-2{stroke:#e74d56;}.cls-3{stroke:#1a1a1a;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 40,
    y1: 80,
    x2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcbd01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcbd01",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#fcbd01",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#fcbd01",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcbd01"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 40,
    cy: 40,
    r: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.75,56c0-6.08-5.26-11-11.75-11S28.25,49.92,28.25,56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24,35.5a4.5,4.5,0,0,0,9,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47,35.5a4.5,4.5,0,0,0,9,0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 44,
    y1: 31,
    x2: 58,
    y2: 25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36,
    y1: 31,
    x2: 22,
    y2: 25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngryUnselected);
export default __webpack_public_path__ + "static/media/angryUnselected.04baf4c48f94f8283c7439be356aecf8.svg";
export { ForwardRef as ReactComponent };